import type { ICourseContentAccessMethodsEnum } from "./types";
import type { IPathBaseParam } from "./path";

import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import type { IResponseOption } from "@/interfaces";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IResponseOption<ICourseContentAccessMethodsEnum>>>,
  IPathBaseParam,
  IPaginationParams
>("selectTypes.courseContentAccessMethods");

export const courseContentAccessMethods = {
  ...getAllApis,
};
